import { fetchApi } from '@/config/axiosSetting.ts';
import { NewFilesListParamsType } from '@/modules/FileList/queries/newFilesList/newFilesListQuery.type.ts';
import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { FullFileType } from '@/modules/FileList/types/FileList.type.ts';

export const newFilesListQueryFunction = (
  params: NewFilesListParamsType,
): Promise<PaginationResponseType<FullFileType[]>> =>
  fetchApi.get('my_files/new_files/list/', { params });
